import gql from 'graphql-tag'
  

export const SEE_REQUESTUSER_CATEGORY = gql`
         query seeRequestUserCategory {
           seeRequestUserCategory {
             id
             categoryName
             categoryCount
             topComment {
               id
               topCommentId
             }
           }
         }
       `;